// extracted by mini-css-extract-plugin
export const placeholder = "Placeholder-module--placeholder--iedOs";
export const pulse = "Placeholder-module--pulse--14B0B";